import { BaseAlign, Color, Font, Label, ScreenElement, TextAlign, vec, Vector } from "excalibur";
import { LevelOne } from "../../scenes/level-one/level-one";
import { CostButton } from "./cost_button";

const padding = 4;

export class DiceButton extends CostButton {
    private costLabel: Label;

    constructor(level: LevelOne, pos: Vector, width: number, height: number, private num: number, cost: number, onSelect: () => void) {
        super(
            level,
            cost,
            onSelect, {
            pos: pos.add(vec(padding, padding)),
            width: width - padding * 2,
            height: height - padding * 2,
            color: new Color(255, 255, 255, 0.3)
        });
    }

    public onInitialize() {
        super.onInitialize();

        this.addChild(
            new Label({
                pos: vec(this.width / 2 - 4, padding * 6),
                text: "Roll " + this.num,
                font: new Font({
                    size: 24,
                    baseAlign: BaseAlign.Top,
                    textAlign: TextAlign.Center,
                }),
            })
        );

        this.costLabel = new Label({
            pos: vec(this.width / 2 - 4, this.height - padding * 6),
            text: `$${this.cost}`,
            font: new Font({
                size: 24,
                baseAlign: BaseAlign.Bottom,
                textAlign: TextAlign.Center,
            }),
        });

        this.addChild(
            this.costLabel
        );
    }
}